import {
  defineSchema,
  SchemaInstance,
} from "@redotech/redo-flows-core-schema-common/type-system/schema";

/**
 * Fake (like baseCheckoutTreeSchema): supplies shipping conditions carry their
 * own operands, so the flow needs no trigger variables — only the editor types.
 */
export const baseSuppliesShippingSchema = defineSchema({ fields: {} });

export const exampleBaseSuppliesShippingInstance: SchemaInstance<
  typeof baseSuppliesShippingSchema
> = {};
